export var getStyles = function (props) {
    var className = props.className;
    return {
        root: {
            padding: 2,
            outline: 'none'
        },
        tableCell: {
            padding: 0
        },
        focusedContainer: [
            'ms-swatchColorPickerBodyContainer',
            {
                clear: 'both',
                display: 'block',
                minWidth: '180px',
            },
            className
        ]
    };
};
//# sourceMappingURL=SwatchColorPicker.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/SwatchColorPicker/SwatchColorPicker.styles.js
// module id = 875
// module chunks = 0